var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.833,
    height: 25.08,
    viewBox: "0 0 41.833 25.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 114",
    transform: "translate(0 1)",
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 2
    },
    d: "M0 0h41.833"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 115",
    transform: "translate(0 12.54)",
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 2
    },
    d: "M0 0h41.833"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 116",
    transform: "translate(0 24.08)",
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 2
    },
    d: "M0 0h41.833"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger-icon.6fa1eeba07cff6418f383f7b4af168a4.svg";
export { ForwardRef as ReactComponent };